import { limitPageRange } from "./getPagination";

const getCurrentPageReducer =
  ({ currentPage, itemsPerPage, totalItems }) =>
  (state, action) => {
    switch (action.type) {
      case "GO_TO_PAGE":
        return limitPageRange(totalItems, itemsPerPage)(action.page);

      case "NEXT_PAGE":
        return limitPageRange(totalItems, itemsPerPage)(currentPage + 1);

      case "PREVIOUS_PAGE":
        return limitPageRange(totalItems, itemsPerPage)(currentPage - 1);

      case "SET_TOTAL_ITEMS":
        return limitPageRange(
          action.totalItems,
          itemsPerPage
        )(action.nextPage ?? state);

      default:
        return state;
    }
  };

const totalItemsReducer = (state, action) => {
  switch (action.type) {
    case "SET_TOTAL_ITEMS":
      return action.totalItems;
    default:
      return state;
  }
};

const itemsPerPageReducer = (state, action) => {
  switch (action.type) {
    case "SET_ITEMS_PER_PAGE":
      return action.itemsPerPage;
    default:
      return state;
  }
};

const paginationStateReducer = (state, action) => ({
  currentPage: getCurrentPageReducer(state)(state.currentPage, action),
  totalItems: totalItemsReducer(state.totalItems, action),
  itemsPerPage: itemsPerPageReducer(state.itemsPerPage, action),
});

export default paginationStateReducer;
